import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";

const getBackgroundColor = (highlightType) => {
  switch (highlightType) {
    case "both":
      return "bg-green-50 border-green-200";
    default:
      return "bg-gray-50 border-gray-200";
  }
};

const getTextColor = (highlightType, isLeftColumn = false) => {
  switch (highlightType) {
    case "both":
      return "text-green-700";
    case "single":
      return isLeftColumn ? "text-gray-700" : "text-blue-700";
    default:
      return isLeftColumn ? "text-gray-700" : "text-blue-700";
  }
};

export default function ComparePlayersTable({
  athleteCompareData,
  currentAthlete,
  selectedAthlete,
  isHighSchoolCoach,
  comparisonRows,
  onViewAthlete,
}) {
  return (
    <div className="grid grid-cols-3 sm:grid-cols-3 gap-0 sm:gap-0 min-w-[600px] sm:min-w-[700px] text-sm overflow-auto">
      <div className="text-gray-600 font-medium"></div>

      <div className="text-center pb-2">
        <div className="w-14 h-14 bg-gray-200 rounded-full mx-auto">
          <img
            alt={athleteCompareData.athleteName}
            src={
              athleteCompareData.athleteProfilePic || "/default-profile-img.png"
            }
            className="object-cover h-full w-full rounded-full"
          />
        </div>
        <h3
          className={`font-semibold mt-2 text-blue-700 text-sm ${
            isHighSchoolCoach ? "" : "cursor-pointer"
          }`}
          onClick={
            isHighSchoolCoach
              ? undefined
              : () => onViewAthlete(athleteCompareData.athleteUserId)
          }
        >
          {athleteCompareData.athleteName}
        </h3>
        <p className="text-gray-700 text-xs">
          {currentAthlete?.primaryPosition}
        </p>
      </div>

      <div className="font-semibold text-sm sm:text-base uppercase absolute left-2/3 transform -translate-x-1/2 top-28 sm:top-28 bg-gray-600 text-white px-2 py-1.5 rounded-full ">
        VS
      </div>

      <div className="text-center pb-2">
        <div className="w-14 h-14 bg-gray-200 rounded-full mx-auto">
          <img
            alt={athleteCompareData.compareToName}
            src={
              athleteCompareData.compareToProfilePic ||
              "/default-profile-img.png"
            }
            className="object-cover h-full w-full rounded-full"
          />
        </div>
        <h3
          className={`font-semibold mt-2 text-blue-700 text-sm ${
            isHighSchoolCoach ? "" : "cursor-pointer"
          }`}
          onClick={
            isHighSchoolCoach
              ? undefined
              : () => onViewAthlete(athleteCompareData.compareToUserId)
          }
        >
          {athleteCompareData.compareToName}
        </h3>
        <p className="text-gray-700 text-xs">
          {selectedAthlete?.primaryPosition}
        </p>
      </div>

      {comparisonRows.map(
        ([label, left, right, best, highlightType = "single"]) => (
          <React.Fragment key={label}>
            <div
              className={`text-gray-700 py-2 border-b ${
                highlightType === "both" ? "bg-green-50 border-green-200" : ""
              }`}
            >
              {label}
            </div>
            <div
              className={`text-left border-t border-l border-r first:border-b last:border-b py-2 flex justify-center items-center gap-3 mr-2 ${getBackgroundColor(
                highlightType,
              )} ${getTextColor(highlightType, true)}`}
            >
              {left}
              {best === "1" && highlightType !== "both" && (
                <FontAwesomeIcon
                  icon={faCircleCheck}
                  className="text-xs sm:text-sm ml-3 text-green-500"
                />
              )}
            </div>
            <div
              className={`text-left border-t border-l border-r first:border-b last:border-b py-2 flex justify-center items-center gap-3 mr-2 ${getBackgroundColor(
                highlightType,
              )} ${getTextColor(highlightType, false)}`}
            >
              {right}
              {best === "2" && highlightType !== "both" && (
                <FontAwesomeIcon
                  icon={faCircleCheck}
                  className="text-xs sm:text-sm ml-3 text-green-500"
                />
              )}
            </div>
          </React.Fragment>
        ),
      )}
    </div>
  );
}
